<wiz-hgroup width="100%" height="100%" verticalAlign="center" horizontalAlign="center" style="padding: 5px">
  <wiz-label #lbName [wizLabel]="data.labelAndDates"></wiz-label>
</wiz-hgroup>
